/** @format */

import { apiCache, CACHE_DURATION } from "@/lib/cache";
import api from "../interceptor";
import { AxiosResponse } from "axios";
const storeID = process.env.NEXT_PUBLIC_STORE_ID || 1;

const url = `/categories`;

export const CategoryAPI = {
  getCategoryWithSlug: async (
    slug: string,
    currentPage: number,
    limit = 4,
    justGetParent = true,
  ) => {
    return await api({
      method: "GET",
      url: `${url}/${slug}`,
      params: {
        storeID,
        justGetParent,
        currentPage,
        limit,
      },
    });
  },

  getAllCategoriesOfStore: async ({
    justGetParent,
    currentPage,
    limit,
    priority,
  }: {
    justGetParent: boolean;
    currentPage?: number;
    limit?: number;
    priority?: boolean;
  }) => {
    const cacheKey = `categories_${storeID}_${justGetParent}_${currentPage ?? "all"}_${limit ?? "all"}_${priority ?? "false"}`;

    return await apiCache.getOrFetch<AxiosResponse>(
      cacheKey,
      CACHE_DURATION.FIVE_MINUTES,
      async () => {
        console.log(`🌐 Đang gọi Fetch Category -List-`);
        return await api({
          method: "GET",
          url: url,
          params: {
            justGetParent,
            storeID,
            limit,
            currentPage,
            priority,
            //     justGetParent,
            //   process.env.STORE_ID
          },
        });
      },
    );
  },
  clearCache: () => {
    apiCache.clear("categories_");
  },
};
